import { render, staticRenderFns } from "./RegularWithExcerpt.vue?vue&type=template&id=267ec2c7&"
import script from "./RegularWithExcerpt.vue?vue&type=script&lang=ts&"
export * from "./RegularWithExcerpt.vue?vue&type=script&lang=ts&"
import style0 from "./RegularWithExcerpt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports